import React, { useEffect, useState } from "react";
import styles from "./DynamicTable.module.css"
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';

export interface ITableData {
    itemSpecificationId: number,
    property: string,
    description: string[]
}
export interface ITableHead {
    id: number,
    heading: string
}

interface PropsType {
    data: ITableData[],
    head: ITableHead[],
}


export default function DynamicTable(props: PropsType) {
    const responsive = useSelector((state: RootState) => state.responsive);
    const [isWeb, setIsWeb] = useState<boolean>(true);

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
    }, [])


    return (
        <React.Fragment>
            <div className={`${styles.mainContainer}`}>
                <table className={`${styles.tableContainer}`}>
                    <tbody>
                        <tr>
                            {props.head.length > 0 ?
                                props.head.map((key, index) => {
                                    return <th className={`${styles.data}`} key={index}>{key}</th>
                                })
                                : null}
                        </tr>
                        {
                            props.data.map((specs, index) => {
                                const { itemSpecificationId, property, description } = specs //destructuring
                                return (
                                    <tr key={itemSpecificationId}>
                                        <td className={`${styles.datatd}`}>{property}</td>
                                        <td className={`${styles.datatd}`}>

                                            {description.map((des) => {
                                                return (
                                                    <span>{des} <br /></span>
                                                )
                                            })
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    )
}